import {
  all, put, takeEvery, select,
} from 'redux-saga/effects';
import {
  change, doSubmit, startSubmit, stopSubmit, reset,
} from 'circe/forms/actions';
import { operatorClient } from 'domain/HttpClients';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import { FORM_NAME } from './constants';

function* doCreateProductType(context, action) {
  if (action.payload.name !== FORM_NAME) return;

  yield put(startSubmit(FORM_NAME));

  try {
    const {
      payload: { values },
    } = action;

    console.log({ values });
    try {
      yield put(startSubmit(FORM_NAME));

      const response = yield operatorClient
        .Patch('api/masheed/constant/sales-categories')
        .withData({
          products: [
            {
              salesCategory: values.saleCategory,
              tag: values.tag,
              truckType: values.vehicleType,
              massPerUOM: values.massPerUOM > 0 ? values.massPerUOM : null,
            },
          ],
        })
        .send();

      yield put(
        showNotification(
          I18n.str('salesCategoryCreatedSuccessfully', 'Sales Category Created Successfully'),
          'success',
        ),
      );
      yield put(reset(FORM_NAME));
      setTimeout(() => {
        context.history.push('/products');
      }, 2000);
    } catch (e) {
      console.error(e);
      throw new Error(e.message);
    }
  } catch (e) {
    const message = e.response && e.response.message
      ? e.response.message
      : I18n.str('error', 'Something Went Wrong, Please try again');

    yield put(showNotification(message, 'error'));
  } finally {
    yield put(stopSubmit(FORM_NAME));
  }
}

function* watcher(context) {
  yield all([takeEvery(doSubmit().type, doCreateProductType, context)]);
}

export default watcher;
